import React, { Component } from 'react';
import SaveSourceDialog from './SaveSourceDialog';
import SourcesGrid from './SourcesGrid';
import SourcesToolbar from './SourcesToolbar';
import Notification from './Notification';

export class Home extends Component {
    static displayName = Home.name;

    constructor(props) {
        super(props);
        this.state = {
            sources: [],
            isLoading: true,
            quickFilterText: "",
            isDialogOpen: false,
            currentSource: {},
            isUpdate: true,
            notificationOpen: false,
            notificationMessage: '',
            notificationSeverity: ''
        };
    }

    render() {
        if (this.state.isLoading) {
            return (
                <React.Fragment>
                    {this.renderNotification()}
                    <div className="loader"></div>
                </React.Fragment>
            )
        }
        else {
            return (
                <React.Fragment>
                    {this.renderNotification()}
                    <SourcesToolbar
                        quickFilterText={this.state.quickFilterText}
                        quickFilterTextChanged={this.updateSearch}
                        quickFilterCanceled={this.updateSearch}
                        createSourceClicked={this.openCreateSourceDialog}
                    />
                    <SourcesGrid
                        quickFilterText={this.state.quickFilterText}
                        sources={this.state.sources}
                        linkClicked={this.openUpdateSourceDialog}
                    />
                    {this.state.isDialogOpen && this.renderSaveDialog()}
                </React.Fragment>
            );
        }
    }

    renderSaveDialog() {
        return (
            <SaveSourceDialog
                key={this.state.currentSource?.name}
                open={this.state.isDialogOpen}
                onClose={this.closeDialog}
                isUpdate={this.state.isUpdate}
                sources={this.state.sources}
                source={this.state.currentSource}
                onCloseClick={this.closeDialog}
                onSuccessfullUpdate={this.onSuccessfullUpdate}
                onSuccessfullCreate={this.onSuccessfullCreate}
                onFailedSave={() => this.displayNotification(`Failed to ${this.state.isUpdate ? 'update' : 'create'} source!`, 'error')}
                onSaveClick={() => this.setState({ isDialogOpen: false })}
            />
        )
    }

    onSuccessfullUpdate = (source) => {
        this.displayNotification(`Source ${source.name} updated successfully!`, 'success');

        this.setState(prevState => {
            let newData = [...prevState.sources];
            let index = newData.findIndex(d => d.id === source.id);
            if (index > -1) {
                newData[index] = source;
            }
            return { sources: newData };
        });
    }

    onSuccessfullCreate = (source) => {
        this.displayNotification(`Source ${source.name} created successfully!`, 'success');
        this.setState(prevState => ({
            sources: [...prevState.sources, source]
        }));
    }

    renderNotification = () => {
        return (
            <Notification
                severity={this.state.notificationSeverity}
                open={this.state.notificationOpen}
                onClose={() => this.setState({ notificationOpen: false })}
                message={this.state.notificationMessage}
            />
        );
    }

    componentDidMount() {
        this.fetchSources();
    }

    openCreateSourceDialog = () => {
        this.setState({
            currentSource: {},
            isDialogOpen: true,
            isUpdate: false
        });
    }

    openUpdateSourceDialog = (data) => {
        this.setState({
            currentSource: data,
            isDialogOpen: true,
            isUpdate: true
        });
    }

    updateSearch = (searchVal) => {
        this.setState({ quickFilterText: searchVal });
    }

    resetSearch = () => {
        this.setState({ quickFilterText: "" });
    }

    closeDialog = () => {
        this.setState({
            isDialogOpen: false
        });
    }

    validateResponse = (response, entity) => {
        if (response.status !== 200) {
            this.displayNotification(`Failed to fetch ${entity}!`, 'error');

            return false;
        }

        return true;
    }

    fetchSources = async () => {
        const response = await fetch('api/sources');
        if (this.validateResponse(response, 'sources')) {
            const data = await response.json();
            this.setState({ sources: data, isLoading: false });
        }
    }

    displayNotification = (message, severity) => {
        this.setState({
            notificationOpen: true,
            notificationMessage: message,
            notificationSeverity: severity
        });
    }
}
